import { render } from "./Result.vue?vue&type=template&id=71740a9a"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"

import "./Result.vue?vue&type=style&index=0&id=71740a9a&lang=css"

import exportComponent from "/tmp/ee3b31a8-ff48-402a-a87e-e17edfb6d8ab/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__